import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import Chip from "@mui/material/Chip";

// Importings from firebase
import { projects } from "./../../config/firebase";

// Colors
import { red } from "@mui/material/colors";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function Porfolio() {
  // const r = red[500];
  // const [project, setProject] = useState([

  // ]);

  const [open, setOpen] = React.useState(false);

  const showAlert = () => {
    setTimeout(() => {
      setOpen(true);
    }, 3000);
  };

  const goToContactPage = useNavigate();

  return (
    <Container>
      {console.log(projects)}
      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Collapse in={open}>
          <Alert
            severity="info"
            action={
              <Tooltip title="Visit Contact Page" placement="top" arrow>
                <Button
                  variant="contained"
                  onClick={() => {
                    // setOpen(false);
                    goToContactPage("/contact");
                  }}
                >
                  Hire me now
                </Button>
              </Tooltip>
            }
            sx={{ mb: 2 }}
          >
            <strong>Did you love me work ?</strong> Please, visit my{" "}
            <strong>contact page</strong> to <i>contact me</i> &amp; download my{" "}
            <strong>CV</strong> 👉
          </Alert>
        </Collapse>
        {showAlert()}
      </Box>
      <Box sx={{ flexGrow: 1, marginTop: "20px", marginBottom: "10px" }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 2, md: 4, lg: 12 }}
        >
          {projects.map((item, index) => (
            <Grid item xs={4} sm={1} md={2} lg={4} key={index}>
              <Item>
                <Card
                  sx={{ maxWidth: "100%", boxShadow: "none" }}
                  key={item.name}
                >
                  <CardMedia
                    component="img"
                    height="100%"
                    image={item.image}
                    alt={item.title}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                    <Stack direction="row" spacing={1} mt={1}>
                      {item.techs.map((tech) => {
                        switch (tech) {
                          case "Angular":
                            return (
                              <Chip label={tech} color="error" size="small" />
                            );
                          case "React":
                            return (
                              <Chip label={tech} color="info" size="small" />
                            );
                          default:
                            return <Chip label={tech} size="small" />;
                        }
                      })}
                    </Stack>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      target="_blank"
                      href={item.liveDemoLink}
                    >
                      Live Demo
                    </Button>
                    <Button target="_blank" href={item.sourceCodeLink}>
                      Source Code
                    </Button>
                  </CardActions>
                </Card>
              </Item>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
